import { conditions, videoTag } from "helpers";
import { sendFluentLog, subtitleLog } from "../../../../../logs";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setSelectedSubtitle, setSubtitleText } from "redux-share/slices/videoDataSlice";
import ChevronRightIcon from "../../icon-components/chevronRight";
import { shallowEqual } from "react-redux";
import { SettingSections } from "interfaces";
import { memo } from "react";

const SubtitlesMenu = ({ setSection }: any) => {
    const dispatch = useAppDispatch();
    const { subtitles, selectedSubtitle } = useAppSelector(
        ({ videoData: { subtitles, selectedSubtitle } }) => ({ subtitles, selectedSubtitle }),
        shallowEqual
    );

    return (
        <div id={SettingSections.subtitles} className="animate__animated animate__fadeIn pl-p-[14px]">
            <div
                className={`pl-flex pl-items-center pl-cursor-pointer pl-gap-2 pl-pb-3 pl-mb-3 pl-border-b pl-border-b-gray-300 dark:pl-border-b-dark-4`}
                onClick={() => setSection(SettingSections.subtitlesSettingMenu)}
            >
                <div className={`pl-rounded-[4px] pl-p-1 pl-bg-gray-300 dark:pl-bg-dark-4`}>
                    <ChevronRightIcon className={`pl-w-3 pl-h-3 pl-bg-gray-300 dark:pl-bg-dark-4`} />
                </div>
                <p className="pl-text-[15px] pl-font-medium">انتخاب زیرنویس</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                <li
                    className={`pl-flex pl-items-center pl-text-[14px] pl-rounded-[4px] pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 pl-pr-2 ${
                        !selectedSubtitle && "pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"
                    }`}
                    onClick={() => {
                        dispatch(setActiveElements(false));
                        dispatch(setSettingPopover(false));
                        dispatch(setSelectedSubtitle(undefined));
                        setSection(SettingSections.main);
                        const result: any = Object.values(videoTag().textTracks).find((textTrack: any) => textTrack.mode === "showing");
                        if (result) result.mode = "disabled";
                        dispatch(setSubtitleText(""));
                        dispatch(setSelectedSubtitle(undefined));
                        sendFluentLog(subtitleLog("empty"));
                    }}
                >
                    بدون زیرنویس
                </li>
                {subtitles.map((subtitle: any, index: number) => (
                    <li
                        key={index}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-rounded-[4px] pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 pl-pr-2 ${
                            selectedSubtitle &&
                            selectedSubtitle.language === subtitle.language &&
                            "pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"
                        }`}
                        onClick={() => {
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                            dispatch(setSelectedSubtitle(subtitle));
                            videoTag().textTracks[index].mode = "showing";
                            setSection(SettingSections.main);
                            sendFluentLog(subtitleLog(subtitle.language));
                        }}
                    >
                        <span>{subtitle.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(SubtitlesMenu);
